import { HeaderLayout0 } from './header-layout-0'
import { HeaderLayout1 } from './header-layout-1'
import { HeaderLayout2 } from './header-layout-2'

export default HeaderLayout2
